var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.905 8.752l-9.051 9.16a.402.402 0 0 1-.227.088.402.402 0 0 1-.227-.089l-5.305-5.37A.295.295 0 0 1 5 12.313c0-.09.032-.166.095-.225l2.188-2.212a.3.3 0 0 1 .223-.09.3.3 0 0 1 .223.09l2.898 2.944L17.27 6.09A.3.3 0 0 1 17.494 6a.3.3 0 0 1 .223.089L19.905 8.3c.063.059.095.134.095.226a.295.295 0 0 1-.095.225z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cb76a8c9997fc25673a21a3cef06e00a.svg";
export { ForwardRef as ReactComponent };